export default {"src":"/_next/static/media/arezzo-media-black.595cf86a.svg","height":75,"width":323};